export default __webpack_public_path__ + "static/media/img--kitchen-1-light.4c1c5058.jpg";